module.exports = __webpack_public_path__ + "images/category_lp/watch/case3_abb8e2982fd12fe7e0fc57eb28ed8af6.jpg";